import useModel from './use-model';

export default (selectedTab = '') => {
  const { prismicGlobalContentModel } = useModel();

  if (selectedTab) {
    return prismicGlobalContentModel[selectedTab] || {};
  }

  return prismicGlobalContentModel;
};



// WEBPACK FOOTER //
// ./src/client/js/view/hooks/use-global-content.js